const { Splide } = require("@splidejs/splide");

const front = {
    env: "preprod",
    init() {
        const pageSlideshows = document.querySelectorAll('.page_slideshow');
        if(pageSlideshows.length){
            pageSlideshows.forEach(slideshow => {
                new Splide( slideshow, {
                    type   : 'slide',
                    speed:1000,
                    arrows: true,
                    pagination: false,
                    autoplay: true,
                    interval: 4000, 
                    pauseOnHover:true,
                    fixedWidth:250,
                    height:408,
                    gap:"2rem",
                    perMove:4,
                    lazyLoad:'sequential',
                    breakpoints: {
                        1560: {
                            perMove: 3,
                        },
                        1200:{
                            perMove: 2,
                        },
                        991:{
                            perMove: 3,
                        },
                        924:{
                            perMove: 2,
                        },
                        592:{
                            perMove: 1,
                        }
                  }
                  } ).mount();
            })
        }
        
    },
};

module.exports = front;
